var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 22,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_15987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4373 8.8829C15.4214 10.1387 16.5564 10.8394 17.4115 11.2561C18.2899 11.6835 18.585 11.9577 18.5815 12.34C18.575 12.925 17.8808 13.1832 17.2312 13.1933C16.0979 13.2108 15.4389 12.8873 14.9151 12.6426L14.5068 14.5529C15.0324 14.7951 16.0056 15.0064 17.0149 15.0156C19.3839 15.0156 20.9337 13.8462 20.9421 12.0331C20.9514 9.73204 17.7593 9.60468 17.7811 8.57616C17.7887 8.26429 18.0862 7.93148 18.7383 7.84686C19.0611 7.80412 19.9521 7.7714 20.9623 8.23659L21.3588 6.38827C20.8155 6.19046 20.1173 6.00105 19.248 6.00105C17.0182 6.00105 15.45 7.18637 15.4373 8.8829ZM25.1686 6.16025C24.7361 6.16025 24.3715 6.41258 24.2088 6.79981L20.8248 14.8799H23.1921L23.6632 13.578H26.5559L26.8292 14.8799H28.9157L27.0949 6.16025H25.1686ZM25.4998 8.51575L26.183 11.7901H24.312L25.4998 8.51575ZM12.5671 6.16036L10.7011 14.8798H12.957L14.8221 6.16014L12.5671 6.16036ZM9.23 6.16036L6.88203 12.0952L5.93224 7.04887C5.8208 6.48554 5.38069 6.16025 4.89195 6.16025H1.05376L1 6.41346C1.78796 6.58444 2.68323 6.86022 3.22562 7.15529C3.55755 7.33555 3.65221 7.49312 3.76125 7.92145L5.56018 14.8799H7.94402L11.5988 6.16025L9.23 6.16036Z",
    fill: "url(#paint0_linear_384_15987)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_384_15987",
    x1: 1284.39,
    y1: 33.0989,
    x2: 1310.49,
    y2: -892.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_15987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9157,
    height: 9.05078,
    fill: "white",
    transform: "translate(1 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e9baee551c7cfd0547e2327a0a5b5377.svg";
export { ForwardRef as ReactComponent };